import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator, BreadcrumbPage } from '../components/ui/breadcrumb';
import SEO from '../components/SEO';

const MentionsLegalesPage = () => {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="mentions-legales-page">
      <SEO 
        title="Mentions Légales | Atlantique Spa Boutique"
        description="Mentions légales du site Atlantique Spa Boutique - Informations sur l'éditeur, l'hébergeur et les conditions d'utilisation."
        canonical="/mentions-legales"
      />
      
      {/* Breadcrumb */}
      <div className="bg-white border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href="/">Accueil</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>Mentions Légales</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-slate-900 mb-8">Mentions Légales</h1>
        
        <div className="prose prose-slate max-w-none">
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">1. Éditeur du site</h2>
            <p className="text-slate-600 leading-relaxed">
              Le présent site est édité par :<br /><br />
              <strong>Atlantique Spa Boutique</strong><br />
              Spécialiste du spa : vente, installation et SAV<br /><br />
              Email : contact@atlantiquespaboutique.com<br />
              Email : contact@atlantiquespaboutique.com<br /><br />
              Zone d'intervention : Loire-Atlantique (44), Vendée (85), Morbihan (56), Maine-et-Loire (49)
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">2. Directeur de la publication</h2>
            <p className="text-slate-600 leading-relaxed">
              Le directeur de la publication est le représentant légal de l'entreprise Atlantique Spa Boutique.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">3. Hébergement</h2>
            <p className="text-slate-600 leading-relaxed">
              Le site est hébergé par un prestataire professionnel garantissant la disponibilité et la sécurité des données.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">4. Propriété intellectuelle</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              L'ensemble du contenu de ce site (textes, images, graphismes, logo, icônes, etc.) est la propriété exclusive 
              d'Atlantique Spa Boutique ou de ses partenaires, et est protégé par les lois françaises et internationales 
              relatives à la propriété intellectuelle.
            </p>
            <p className="text-slate-600 leading-relaxed">
              Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, 
              quel que soit le moyen ou le procédé utilisé, est interdite sans autorisation écrite préalable.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">5. Limitation de responsabilité</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Atlantique Spa Boutique s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. 
              Toutefois, Atlantique Spa Boutique ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations 
              mises à disposition sur ce site.
            </p>
            <p className="text-slate-600 leading-relaxed">
              En conséquence, Atlantique Spa Boutique décline toute responsabilité pour toute imprécision, inexactitude ou omission 
              portant sur des informations disponibles sur ce site.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">6. Liens hypertextes</h2>
            <p className="text-slate-600 leading-relaxed">
              Le site peut contenir des liens vers d'autres sites. Atlantique Spa Boutique n'exerce aucun contrôle sur ces sites 
              et décline toute responsabilité quant à leur contenu et aux services qui y sont proposés.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">7. Droit applicable</h2>
            <p className="text-slate-600 leading-relaxed">
              Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux français 
              seront seuls compétents.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">8. Contact</h2>
            <p className="text-slate-600 leading-relaxed">
              Pour toute question relative aux mentions légales, vous pouvez nous contacter :<br />
              Email : contact@atlantiquespaboutique.com<br />
              Email : contact@atlantiquespaboutique.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegalesPage;
